import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import { db } from "../plugins/firebase";
import FirestoreDao from "../dao/firestoreDao";
import { getLineUserId } from "../util/liff_util";

import { ORDER_STATUS_USER } from "../constants/order_constants";
import {
  CHECK_TYPE,
  CART_ITEM,
} from "../util/order_util";
import { ORDER_ACCEPT_STATUS } from "../util/about_util";
import { VALIDATE_VISITTIME } from "../constants/validate_visittime";

// module
import moduleRest from '@/store/modules/rest';
import moduleSettings from '@/store/modules/settings';

const NO_IMAGE = require("@/assets/noimage.png");

Vue.use(Vuex);

// const sleep = async (msec) => {
//   return new Promise(function (resolve) {
//     setTimeout(resolve, msec);
//   });
// }
// const occurError = () => {
//   throw new Error("test");
// }

const store = new Vuex.Store({
  modules: {
    rest: moduleRest,
    settings: moduleSettings,
  },
  state: {
    debug: process.env.VUE_APP_DEBUG === "true",
    appBar: false,
    arrow: false,
    title: "",
    allowPc: false, // PC表示許可
    cart: false, // アイコン表示可否 (各Componentで設定)
    cartDoAnimate: false, // アニメーション可否
    cartItemSize: 0, // アイテム数

    // 基本情報
    shopId: null,
    dao: null,
    progress: false,

    // LINE関係
    // userId: "", // 未使用 (getterのみで運用)
    lineToken: null, // LINE
    idToken: null, // Firebase Auth

    // cache
    receivableSetting: null, // 受取時間関係設定
    orderAcceptStatus: null, // 注文受付状態(店舗)
    userOrderStatus: null, // ユーザ注文状態
    about: null, // 店舗情報
    iconUrl: null, // アイコン画像 (ふきだし)
    bubble: null, // 店舗情報(ふきだし)
    taxSettings: null, // 消費税関係
    menusViewData: [], // メニュー一覧(表示用全データ)
    menus: [], // メニュー一覧
    menu: null, // メニュー詳細
    cartViewData: null, // カート(表示用全データ)
    stepViewData: null, // ステップ(表示用全データ)
    historyOrdersViewData: null, // 注文履歴一覧(表示用全データ)
    historyOrders: [], // 注文履歴
    order: null, //注文履歴詳細 or 注文詳細
  },
  mutations: {
    cartItemSize (state, val) { state.cartItemSize = val; },

    shopId (state, val) { state.shopId = val; },
    dao (state, val) { state.dao = val; },
    progress (state, val) { state.progress = val; },
    lineToken (state, val) { state.lineToken = val; },
    idToken (state, val) { state.idToken = val; },

    receivableSetting (state, receivableSetting) { state.receivableSetting = receivableSetting; },
    orderAcceptStatus (state, val) { state.orderAcceptStatus = val; },
    userOrderStatus (state, val) { state.userOrderStatus = val; },
    about (state, val) { state.about = val; },
    iconUrl (state, val) { state.iconUrl = val; },
    bubble (state, val) { state.bubble = val },
    taxSettings (state, val) { state.taxSettings = val },
    menus (state, val) { state.menus = val; },
    menu (state, val) { state.menu = val; },
    menusViewData (state, val) { state.menusViewData = val; },
    cartViewData (state, val) { state.cartViewData = val; },
    stepViewData (state, val) { state.stepViewData = val; },
    historyOrdersViewData (state, val) { state.historyOrdersViewData = val; },
    historyOrders (state, val) { state.historyOrders = val; },
    order (state, val) { state.order = val; },
  },
  getters: {
    // header
    appBar: (state) => state.appBar,
    arrow: (state) => state.arrow,
    title: (state) => state.title,
    cart: (state) => state.cart,

    cartDoAnimate: (state) => state.cartDoAnimate,
    cartItemSize: (state) => state.cartItemSize,

    allowPc: (state) => state.allowPc,
    debug: (state) => state.debug,
    shopId: (state) => state.shopId,
    dao: (state) => state.dao,
    progress: (state) => state.progress,
    idToken: (state) => state.idToken,

    userId: () => {
      if (
        process.env.VUE_APP_DEBUG == "true" &&
        process.env.VUE_APP_USE_LINE_USER_ID == "true") {
        return process.env.VUE_APP_DEBUG_LINE_USER_ID;
      } else {
        return getLineUserId();
      }
    },

    receivableSetting: (state) => state.receivableSetting,
    orderAcceptStatus: (state) => state.orderAcceptStatus,
    userOrderStatus: (state) => state.userOrderStatus,
    about: (state) => state.about,
    iconUrl: (state) => {
      if (state.iconUrl) {
        return state.iconUrl;
      } else {
        return NO_IMAGE;
      }
    },
    bubble: (state) => state.bubble,
    taxSettings: (state) => state.taxSettings,
    menus: (state) => state.menus,
    menu: (state) => state.menu,
    menusViewData: (state) => state.menusViewData,
    cartViewData: (state) => state.cartViewData,
    stepViewData: (state) => state.stepViewData,
    historyOrdersViewData: (state) => state.historyOrdersViewData,
    historyOrders: (state) => state.historyOrders,
    order: (state) => state.order,
  },
  actions: {
    showProgress () {
      this.commit("progress", true);
    },
    hideProgress () {
      this.commit("progress", false);
    },
    async initDao (context) {
      // liff 用各種設定取得
      // (前提 -> liff 用設定は取得済)
      const shopId = context.getters.shopId; // ShopsRootPage で設定
      const shopsRoot = context.getters["settings/db"].shopsRoot;
      const tmpOrders = context.getters["settings/db"].tmpOrders;

      // DAO 初期化
      this.commit("dao", null);
      const rootDoc = `${shopsRoot}/${shopId}`;
      const dao = new FirestoreDao(db, rootDoc, tmpOrders);
      this.commit("dao", dao);

      // about 取得 (各種リソースのために必ず1度取得しておく)
      this.dispatch("fetchAbout");

      return dao;
    },
    async getDAO (context) {
      let dao = context.getters.dao;
      if (dao != null) {
        return dao;
      }
      return this.dispatch("initDao");
    },
    // カートアイコン変更
    async fetchCartItemSize (context) {
      // console.log("### fetchCartItemSize");
      const userId = context.getters.userId;
      if (!userId) {
        throw new Error("userId is empty");
      }

      // カート内アイテム 取得
      const dao = await this.dispatch("getDAO");
      const size = await dao.countCartData(userId);
      context.commit("cartItemSize", size);
      console.log("cartItemSize", size);
    },
    // 店舗情報 取得
    async fetchAbout (context) {
      // console.log("### fetchAbout");
      context.commit("about", null);
      const dao = await this.dispatch("getDAO");
      const about = await dao.findAbout();
      context.commit("about", about);
      context.commit("iconUrl", about.iconUrl); // アイコン画像
      console.log("about", about);
    },
    // ふきだし情報(個別) 取得 ★現在はカートのみ
    async fetchBubble (context) {
      // console.log("### fetchBubble");
      context.commit("bubble", null);
      if (!context.getters.about) {
        await this.dispatch("fetchAbout");
      }
      const bubble = context.getters.about.bubble;
      // console.log(`bubble=${JSON.stringify(bubble)}`);
      context.commit("bubble", bubble);
      console.log("bubble", bubble);
    },
    // 消費税設定 取得
    async fetchTaxSettings (context) {
      // console.log("### fetchTaxSettings");
      context.commit("taxSettings", null);
      const dao = await this.dispatch("getDAO");
      const settings = await dao.findSettings();
      const taxSettings = settings.consumptionTax;
      context.commit("taxSettings", taxSettings);
      console.log("taxSettings", taxSettings);
    },
    // メニュー一覧 取得
    async fetchMenus (context) {
      // console.log("### fetchMenus");
      context.commit("menus", []);
      const publish = true; // 公開メニューのみ
      const dao = await this.dispatch("getDAO");
      const menus = await dao.findMenus(publish);
      context.commit("menus", menus);
      console.log("menus", menus);
    },
    // 注文履歴一覧 取得
    async fetchHistoryOrders (context) {
      // console.log("### fetchHistoryOrders");
      context.commit("historyOrders", []);
      const userId = context.getters.userId;
      if (!userId) {
        throw new Error("userId is empty");
      }
      const dao = await this.dispatch("getDAO");
      const orders = await dao.findHistoryOrders(userId);
      context.commit("historyOrders", orders);
      console.log("historyOrders", orders);
    },
    // 受取時間関係設定 取得
    async fetchReceivableSetting (context) {
      // console.log("### fetchReceivableSetting");
      context.commit("receivableSetting", null);
      const settings = await this.dispatch("rest/getReceivableSetting");
      context.commit("receivableSetting", settings);
      console.log("receivableSetting", settings);
    },
    // 注文受付状態 取得
    async fetchOrderAcceptStatus (context) {
      // console.log("### fetchOrderAcceptStatus");
      context.commit("orderAcceptStatus", null);
      const orderAcceptStatus = await this.dispatch("rest/getOrderAcceptStatus");
      context.commit("orderAcceptStatus", orderAcceptStatus);
      console.log("orderAcceptStatus", orderAcceptStatus);
    },
    async compareOrderVersionId (context, { orderVersionId }) {
      const dao = await this.dispatch("getDAO");
      const about = await dao.findAbout();
      const currentVersionId = about.orderVersionId;
      // console.log("compareOrderVersionId", orderVersionId, currentVersionId)
      return currentVersionId == orderVersionId; // 「どちらも空(null,undefined)」の場合はOKとみなす
    },
    async compareWithLatestMenu (context, { menu }) {
      // 最新値取得 (/menus)
      const menuId = menu.menuId;
      const dao = await this.dispatch("getDAO");
      const nowMenu = await dao.findMenu(menuId);

      // 削除チェック (/menus 内に存在しない)
      if (!nowMenu) {
        return CART_ITEM.DELETED;
      }

      // 更新チェック
      // 更新日付(updatedAt) 表示値 < 最新値
      // console.log("menu", menu.updatedAt);
      // console.log("nowMenu", nowMenu.updatedAt);
      const updatedAt = moment(menu.updatedAt.toDate());
      const nowUpdatedAt = moment(nowMenu.updatedAt.toDate());
      // console.log(`[compareWithLatestMenu]`, updatedAt, nowUpdatedAt);
      if (updatedAt.isBefore(nowUpdatedAt)) {
        return CART_ITEM.UPDATED; // 更新あり
      }
      return CART_ITEM.OK;
    },
    async deleteCartMenusPhysically (context) {
      const dao = await this.dispatch("getDAO");
      const userId = context.getters.userId;

      // 論理削除対象の cartMenuId のみ抽出
      const cartMenuIds = await dao.findCartMenuIdsLogicallyDelete(userId);

      // 物理削除
      const deleteTasks = cartMenuIds.map(cartMenuId => dao.deleteCartMenuData(userId, cartMenuId));
      return Promise.all(deleteTasks);
    },
    async isOrderPassed (context, { queryCartId }) {
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      const passed = await dao.isOrderPassed(userId, queryCartId);
      return passed;
    },
    //------------------------------
    // メニュー
    // TODO module 化
    //------------------------------
    /**
     * 表示データ一括取得 (メニュー一覧)
     */
    async fetchMenuListData (context) {
      try {
        context.commit("menusViewData", null);
        await this.dispatch("getDAO"); // cache 化

        await Promise.all([
          this.dispatch("fetchAbout"),
          this.dispatch("fetchMenus"),
          this.dispatch("fetchCartItemSize"),
          this.dispatch("fetchOrderAcceptStatus"),
        ]);

        const viewData = {};
        viewData.about = context.getters.about;
        viewData.menus = context.getters.menus;
        viewData.orderAcceptStatus = context.getters.orderAcceptStatus;
        console.log("menusViewData", viewData);
        context.commit("menusViewData", viewData);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    // メニュー詳細 取得
    async fetchMenu (context, { id }) {
      console.log("#fetchMenu", id);
      context.commit("menu", null);
      const dao = await this.dispatch("getDAO");
      const menu = await dao.findMenu(id);
      context.commit("menu", menu);
      console.log("menu", menu);
    },
    // メニュー詳細 取得 (for カート)
    async fetchMenuForCart (context, { cartMenuId }) {
      console.log("#fetchMenuForCart", cartMenuId);
      context.commit("menu", null);
      const userId = context.getters.userId;

      const dao = await this.dispatch("getDAO");
      const menu = await dao.createMenuDataFromCart(userId, cartMenuId);
      context.commit("menu", menu);
      console.log("menu", menu);
    },
    // メニュー詳細 取得 (for 注文履歴)
    async fetchMenuForHistory (context, { orderId, orderMenuId }) {
      console.log("#fetchMenuForHistory", orderId, orderMenuId);
      context.commit("menu", null);
      const dao = await this.dispatch("getDAO");
      const menu = await dao.createMenuDataFromHistory(orderId, orderMenuId);
      context.commit("menu", menu);
      console.log("menu", menu);
    },
    async addCartMenu (context, { menu }) {
      console.log("#addCartMenu", menu);
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      return dao.addCart(userId, menu);
    },
    async updateCartMenu (context, { menu }) {
      console.log("#updateCartMenu", menu);
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      return dao.updateCart(userId, menu);
    },
    /**
     * チェック
     * - メニュー詳細 追加押下時
     * - カート画面 編集押下時
     */
    async checkBeforeMenuAction (context, { menu }) {
      // サービス稼働中かどうか
      const active = await this.dispatch("rest/isServiceStatusActive");
      if (!active) {
        return { type: CHECK_TYPE.SERVICE_ACTIVE, result: false };
      }

      // ユーザ注文状態が「注文確認中」かどうか
      const userOrderStatus = await this.dispatch("rest/getUserOrderStatusRecent");
      if (userOrderStatus == ORDER_STATUS_USER.IN_CONFIRM) {
        return { type: CHECK_TYPE.USER_STATUS_IN_CONFIRM, result: false };
      }

      // メニュー最新値(/menus) と比較
      const compareResult = await this.dispatch("compareWithLatestMenu", { menu });
      if (
        compareResult === CART_ITEM.UPDATED ||
        compareResult === CART_ITEM.DELETED
      ) {
        return { type: CHECK_TYPE.MST_MENU_CHANGED, result: false };
      }

      // すべて OK
      return { result: true };
    },
    //------------------------------
    // カート
    // TODO module 化
    //------------------------------
    /**
     * 表示データ一括取得 (カート)
     */
    async fetchCartData (context) {
      try {
        context.commit("cartViewData", null);
        await this.dispatch("getDAO"); // cache 化

        // カートデータ作成
        const cartData = await this.dispatch("createCartData");
        const menus = cartData.menus;

        // カートデータありの場合のみ
        if (menus && menus.length !== 0) {
          await Promise.all([
            this.dispatch("fetchBubble"),
            this.dispatch("fetchTaxSettings"),
            this.dispatch("rest/checkItemsInCart"),
          ]);
        }

        const cartViewData = {};
        cartViewData.cartData = cartData;
        cartViewData.bubble = context.getters.bubble;
        cartViewData.taxSettings = context.getters.taxSettings;
        cartViewData.cartCheckResult = context.getters["rest/cartCheckResult"];
        console.log("cartViewData", cartViewData);
        context.commit("cartViewData", cartViewData);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async createCartData (context) {
      console.log("#createCartData");
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      const cartData = await dao.createCartData(userId);
      console.log("cartData", cartData);
      return cartData;
    },
    async deleteCartMenu (context, { menu }) {
      // カートデータ削除 (物理)
      console.log("#deleteCartMenu", menu);
      const userId = context.getters.userId;
      const menuId = menu.cartMenuId;
      const dao = await this.dispatch("getDAO");
      return dao.deleteCartMenuData(userId, menuId);
    },
    async updateCartId (context,) {
      // カートID 更新
      console.log("#updateCartId");
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      return dao.updateCartId(userId);
    },
    /**
     * チェック
     * - カート画面 追加押下時
     */
    async checkBeforeAddAction () {
      // サービス稼働中かどうか
      const active = await this.dispatch("rest/isServiceStatusActive");
      if (!active) {
        return { type: CHECK_TYPE.SERVICE_ACTIVE, result: false };
      }

      // ユーザ注文状態が「注文確認中」かどうか
      const userOrderStatus = await this.dispatch("rest/getUserOrderStatusRecent");
      if (userOrderStatus == ORDER_STATUS_USER.IN_CONFIRM) {
        return { type: CHECK_TYPE.USER_STATUS_IN_CONFIRM, result: false };
      }

      // すべて OK
      return { result: true };
    },
    /**
     * チェック
     * - カート画面 次へ押下時
     */
    async checkBeforeNextAction () {
      // サービス稼働中かどうか
      const active = await this.dispatch("rest/isServiceStatusActive");
      if (!active) {
        return { type: CHECK_TYPE.SERVICE_ACTIVE, result: false };
      }

      // ユーザ注文状態が「注文確認中」かどうか
      const userOrderStatus = await this.dispatch("rest/getUserOrderStatusRecent");
      if (userOrderStatus == ORDER_STATUS_USER.IN_CONFIRM) {
        return { type: CHECK_TYPE.USER_STATUS_IN_CONFIRM, result: false };
      }

      // 注文状態チェック
      const settings = await this.dispatch("rest/getReceivableSetting");
      const orderAcceptStatus = settings.orderAcceptStatus;
      if (orderAcceptStatus == ORDER_ACCEPT_STATUS.SUSPENDED) {
        // 一時停止
        return { type: CHECK_TYPE.SHOP_STATUS_SUSPENDED, result: false };
      } else if (orderAcceptStatus == ORDER_ACCEPT_STATUS.NOT_ACCEPTED) {
        // 受付停止
        return { type: CHECK_TYPE.SHOP_STATUS_NOT_ACCEPTED, result: false };
      }

      // 最短受取日時が提供可能範囲内かどうか
      const withinRange = settings.range.withinRange;
      if (!withinRange) {
        return { type: CHECK_TYPE.ORDER_TIME_IN_RANGE, result: false };
      }

      // カート内アイテムチェック
      const cartCheckResult = await this.dispatch("rest/checkItemsInCart");
      // console.log(`[cartCheckResult]`, cartCheckResult);
      if (
        cartCheckResult === CART_ITEM.UPDATED ||
        cartCheckResult === CART_ITEM.DELETED
      ) {
        return { type: CHECK_TYPE.MST_MENU_CHANGED, result: false };
      }

      // すべて OK
      return { result: true };
    },
    //------------------------------
    // ステップ
    //------------------------------
    /**
     * 表示データ一括取得 (ステップ)
     */
    async fetchStepData (context) {
      try {
        context.commit("stepViewData", null);
        await this.dispatch("getDAO"); // cache 化

        await Promise.all([
          this.dispatch("fetchCartItemSize"),
          this.dispatch("rest/getReceivableSetting"), // rest/settings
          this.dispatch("rest/getUserOrderStatusRecent"), // rest/userOrderStatus
        ]);

        const viewData = {};
        viewData.settings = context.getters["rest/settings"];
        viewData.userOrderStatus = context.getters["rest/userOrderStatus"];
        console.log("stepViewData", viewData);
        context.commit("stepViewData", viewData);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async updateOrderWay (context, { orderStepData }) {
      // DB更新(選択情報) --> DBフラグON(最終確認)
      console.log("#updateOrderWay");
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      return dao.updateOrderWay(userId, orderStepData);
    },
    /**
     * チェック
     * - ステップ画面 次へ押下時 (最後)
     */
    async checkBeforeNextStepAction () {
      // サービス稼働中かどうか
      const active = await this.dispatch("rest/isServiceStatusActive");
      if (!active) {
        return { type: CHECK_TYPE.SERVICE_ACTIVE, result: false };
      }

      // すべて OK
      return { result: true };
    },
    //------------------------------
    // 決済方法選択
    //------------------------------
    /**
     * チェック
     * - 決済方法選択 初期表示時
     * @param {string} queryCartId カートID (クエリパラメータ)
     * @returns 
     */
    async checkBeforeInit (context, { queryCartId }) {
      // カートデータ取得
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      const cartData = await dao.findCartOverview(userId);

      // 現在のカートID
      const currentCartId = cartData.cartId;
      if (!currentCartId) {
        // 選択不可 (カートクリア済)
        console.log("cart already cleared");
        return { result: false }; // not implemented -> 読込失敗ページ
      }

      // 注文が有効かどうか
      const validateOrder = await this.dispatch("validateCartAndPaidStatus", { queryCartId, currentCartId });
      if (!validateOrder) {
        // もともとは「この注文は無効です(xxx)」
        return { type: CHECK_TYPE.ORDER_AVAILABLE, result: false }; // カートシート
      }

      // サービス稼働中かどうか
      const active = await this.dispatch("rest/isServiceStatusActive");
      if (!active) {
        return { type: CHECK_TYPE.SERVICE_ACTIVE, result: false };
      }

      // 注文状態チェック
      const settings = await this.dispatch("rest/getReceivableSetting");
      const orderAcceptStatus = settings.orderAcceptStatus;
      if (orderAcceptStatus == ORDER_ACCEPT_STATUS.SUSPENDED) {
        // 一時停止
        return { type: CHECK_TYPE.SHOP_STATUS_SUSPENDED, result: false };
      } else if (orderAcceptStatus == ORDER_ACCEPT_STATUS.NOT_ACCEPTED) {
        // 受付停止
        return { type: CHECK_TYPE.SHOP_STATUS_NOT_ACCEPTED, result: false };
      }

      // 受取日時チェック
      const visitTime = cartData.visitTime; // 受取日時 (カート内)
      const availableVisitTime = await this.dispatch("validateVisitTime", { visitTime });
      if (!availableVisitTime) {
        return { type: CHECK_TYPE.USER_VISIT_TIME, result: false };
      }

      // カート内アイテムチェック
      const cartCheckResult = await this.dispatch("rest/checkItemsInCart");
      // console.log(`[cartCheckResult]`, cartCheckResult);
      if (cartCheckResult === CART_ITEM.SOLDOUT) {
        // シート表示 (カート表示)
        return { type: CHECK_TYPE.MST_MENU_SOLDOUT, result: false };
      } else if (
        cartCheckResult === CART_ITEM.UPDATED ||
        cartCheckResult === CART_ITEM.DELETED
      ) {
        return { type: CHECK_TYPE.MST_MENU_CHANGED, result: false };
      }

      // すべて OK
      return { result: true };
    },
    async validateCartAndPaidStatus (context, { queryCartId, currentCartId }) {
      // 注文が通っているかチェック
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      const passed = await dao.isOrderPassed(userId, queryCartId);
      if (passed) {
        // 注文が通っている
        console.log("already paid");
        return false;
      }

      // カートIDチェック
      const compareCartId = queryCartId == currentCartId;
      if (!compareCartId) {
        // 選択不可 (カート更新済み)
        console.log("cart updated");
        return false;
      }
      return true;
    },
    async validateVisitTime (context, { visitTime }) {
      if (!visitTime) {
        return false;
      }

      // 受取日時チェック
      const visitTimeYMD = moment(visitTime.toDate()).format("YYYY-MM-DD");
      const visitTimeHHMM = moment(visitTime.toDate()).format("HH:mm");
      const res = await this.dispatch("rest/validateVisitTime", {
        visitTimeYMD: visitTimeYMD,
        visitTimeHHMM: visitTimeHHMM,
      });
      console.log("validateVisitTime", res);
      return res.result === VALIDATE_VISITTIME.OK;
    },
    //------------------------------
    // 注文履歴
    // TODO module 化
    //------------------------------
    /**
     * 表示データ一括取得 (注文履歴一覧)
     */
    async fetchHistoryListData (context) {
      try {
        context.commit("historyOrdersViewData", null);
        await this.dispatch("getDAO"); // cache 化
        await Promise.all([
          this.dispatch("fetchCartItemSize"),
          this.dispatch("fetchHistoryOrders"),
        ]);

        const viewData = {};
        viewData.historyOrders = context.getters.historyOrders;
        // console.log("historyOrdersViewData", viewData);
        context.commit("historyOrdersViewData", viewData);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    // 注文履歴詳細 取得
    async fetchHistoryData (context, { id }) {
      console.log("#fetchHistoryData", id);
      context.commit("order", null);
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      const order = await dao.findHistoryOrder(userId, id);
      context.commit("order", order);
      console.log("order", order);
    },
    //------------------------------
    // 注文情報
    // TODO module 化
    //------------------------------
    // 注文情報 取得
    async fetchHistoryOrderByCartId (context, { queryCartId }) {
      console.log("#fetchHistoryOrderByCartId", queryCartId);
      context.commit("order", null);
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");
      const order = await dao.findHistoryOrderByCartId(userId, queryCartId);
      context.commit("order", order);
      console.log("order", order);
    },
    /**
     * チェック
     * - 注文情報 初期表示時
     * @param {string} queryCartId カートID (クエリパラメータ)
     * @returns 
     */
    async checkBeforeInitNotPassed (context, { queryCartId }) {
      // カートデータ取得
      const userId = context.getters.userId;
      const dao = await this.dispatch("getDAO");

      // 現在のカートID
      const currentCartId = await dao.getCurrentCartId(userId);
      const isSameCartId = currentCartId && currentCartId == queryCartId;
      if (!isSameCartId) {
        return { type: CHECK_TYPE.MST_MENU_CHANGED, result: false };
      }

      // カート内アイテムチェック
      const cartCheckResult = await this.dispatch("rest/checkItemsInCart");
      if (cartCheckResult === CART_ITEM.SOLDOUT ||
        cartCheckResult === CART_ITEM.UPDATED ||
        cartCheckResult === CART_ITEM.DELETED
      ) {
        return { type: CHECK_TYPE.MST_MENU_CHANGED, result: false };
      }

      // すべて OK
      return { result: true };
    },
    // 注文情報 取得 (仮注文データ)
    async fetchTempOrderData (context) {
      console.log("#fetchTempOrderData");
      context.commit("order", null);

      const dao = await this.dispatch("getDAO");

      // カートデータ作成
      const cartData = await this.dispatch("createCartData");
      const cartMenus = cartData.menus;

      // 設定取得
      const settings = await dao.findSettings();

      const tmpOrder = {};
      tmpOrder.menus = cartMenus;
      tmpOrder.settings = settings;

      context.commit("order", tmpOrder);
      console.log("order", tmpOrder);
    },
  },
});

export default store;
